// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3_Tga","noInteraction":"EventWrapper_noInteraction__2PFOW","pointerPassthrough":"EventWrapper_pointerPassthrough__1wlFM"};